import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import { generalConfigurationService } from '../../../../../services/generalConfiguration.service'
import { GENERAL_CONFIGURATIONS } from '@colven/common-domain-lib/lib'

export default {
    name: 'ReminderTabComponent',
    components: {
        TreeSelectorComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        remindersData: [],
        selectAllDefault: true
    }),
    computed: {
    },
    created () {
    },
    beforeDestroy() {
    },
    mounted () {
        if(!this.model.update) {
            this.getRemindersExpirationsType()
        }
    },
    methods: {
        selectorMapper(node) {
            return {
                id: node.id,
                label: node.name
            }
        },
        updateSelected(reminderBy) {
            this.model.reminderBy = reminderBy;
        },
        async getRemindersExpirationsType() {
            this.remindersData = await generalConfigurationService.getByKey(GENERAL_CONFIGURATIONS.REMINDER_EXPIRATION_TYPES)
            if(this.remindersData){
                if (this.model.reminderBy === null || this.model.reminderBy.length === 0) {
                    // alta de equipo
                    this.model.reminderBy = this.remindersData.map(data => {return data.id})
                    this.selectAllDefault = true
                } else {
                    this.selectAllDefault = false
                }
            }
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.thingDataTabForm) {
                this.$refs.thingDataTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
    }
}
